// import COMPANY_API from '@/api/masterData/company.js';

// 默认表头
export const defaultTableColumn = [
  {
    type: 'checkbox',
    visible: true,
    width: '50',
    fixed: 'left',
  },
  {
    field: 'trackNo',
    title: '运单号',
    width: '100',
    visible: true,
  },
  {
    field: 'actualTransportCarNo',
    title: '实际运输车牌号',
    visible: true,
    width: '110',
  },

  {
    field: 'driverName',
    title: '司机姓名',
    width: '100',
    visible: true,
  },
  {
    field: 'driverPhone',
    title: '司机电话',
    width: '100',
    visible: true,
  },

  {
    field: 'originalPrice',
    title: '单价',
    width: '100',
    visible: true,
  },
  {
    field: 'quantity',
    title: '数量',
    width: '100',
    visible: true,
  },
  {
    field: 'originalAmount',
    title: '金额',
    width: '100',
    visible: true,
  },

  {
    field: 'actualPickupDate',
    title: '实际提货日期',
    width: '100',
    visible: true,
  },
  {
    field: 'actualLoadeCompletedDate',
    title: '实际发车日期',
    width: '100',
    visible: true,
  },
  {
    field: 'actualDeliveryDate',
    title: '实际送货日期',
    visible: true,
    width: '100',
  },
  {
    field: 'actualSignDate',
    title: '实际签收日期',
    visible: true,
    width: '100',
  },
  {
    field: 'actualReceiptDate',
    title: '实际回单时间',
    visible: true,
    width: '100',
  },
];
export const tableList = [
  {
    id: 1,
    payableSettlementNo: 1111,
    settlementDesc: '说明',
    companyName: 'A',
    departmentName: 'b',
    originalTotalAmount: 1,
    domesticTotalAmount: 1,
    currencyName: 'TEST',
    contractNo: 66666,
    projectInitiationNo: 88888,
    productName: '乐百氏',
  },
  {
    id: 2,
    payableSettlementNo: 2222,
    settlementDesc: 'eee',
    companyName: ' B',
    departmentName: 'c',
    originalTotalAmount: 2,
    domesticTotalAmount: 2,
    currencyName: 'TEST',
    contractNo: 88888,
    projectInitiationNo: 99999,
    productName: '可乐',
  },
  {
    id: 3,
    payableSettlementNo: 3333,
    settlementDesc: 'eee',
    companyName: ' B',
    departmentName: 'c',
    originalTotalAmount: 3,
    domesticTotalAmount: 3,
    currencyName: 'TEST',
    contractNo: 88888,
    projectInitiationNo: 99999,
    productName: '可乐',
  },
  {
    id: 4,
    payableSettlementNo: 4444,
    settlementDesc: 'eee',
    companyName: ' B',
    departmentName: 'c',
    originalTotalAmount: 4,
    domesticTotalAmount: 4,
    currencyName: 'TEST',
    contractNo: 88888,
    projectInitiationNo: 99999,
    productName: '可乐',
  },
  {
    id: 5,
    payableSettlementNo: 5555,
    settlementDesc: 'eee',
    companyName: ' B',
    departmentName: 'c',
    originalTotalAmount: 5,
    domesticTotalAmount: 5,
    currencyName: 'TEST',
    contractNo: 88888,
    projectInitiationNo: 99999,
    productName: '可乐',
  },
];
